import 'core-js/modules/es.object.assign.js';
import { __rest } from '../../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { Switch as Switch$1, switchClasses, FormControlLabel } from '@mui/material';
import { styled } from '@mui/material/styles';
import { spacing, css, alpha } from '@mui/system';
import { switchProp } from 'styled-tools';
import { shouldNotForwardProps, palette, withUtility } from '../../foundation/utils.js';

let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4;
const Content = styled(Switch$1, {
  shouldForwardProp: shouldNotForwardProps
})(_t || (_t = _`
  ${0};

  width: ${0};
  height: ${0};
  padding: 0;

  & .${0} {
    width: ${0};
    height: ${0};
    box-sizing: border-box;
    background-color: ${0};
    box-shadow: none;
  }

  & .${0} {
    border-radius: 25px;
    background-color: ${0};
    border: 1px solid ${0};
    opacity: 1;
  }

  & .${0} .${0} {
    width: ${0};
    height: ${0};
    background-color: ${0};
  }

  ${0}

  & .${0} {
    padding: 0;
    transition-duration: 300ms;
    margin: ${0};

    &.${0} {
      margin: ${0};
      transform: translateX(
        ${0}
      );

      & + .${0} {
        background-color: ${0};
        border: 1px solid ${0};
        opacity: 1;
      }

      &.${0} + .${0} {
        opacity: 0.5;
      }
    }
  }

  ${0}
`), spacing, switchProp('size', {
  small: '40px',
  medium: '52px'
}), switchProp('size', {
  small: '24px',
  medium: '32px'
}), switchClasses.thumb, switchProp('size', {
  small: '12px',
  medium: '16px'
}), switchProp('size', {
  small: '12px',
  medium: '16px'
}), palette('outline'), switchClasses.track, palette('surfaceAt1'), palette('outline'), switchClasses.checked, switchClasses.thumb, switchProp('size', {
  small: '18px',
  medium: '24px'
}), switchProp('size', {
  small: '18px',
  medium: '24px'
}), palette('onPrimary'), withUtility(({
  palette
}) => css(_t2 || (_t2 = _`
      & .${0} + .${0} {
        background-color: ${0};
        border: 1px solid ${0};
        opacity: 1;
      }

      & .${0} .${0} {
        background-color: ${0};
      }
    `), switchClasses.disabled, switchClasses.track, alpha(palette('onBackground'), 0.12), alpha(palette('onBackground'), 0.12), switchClasses.disabled, switchClasses.thumb, alpha(palette('onBackground'), 0.38))), switchClasses.switchBase, switchProp('size', {
  small: '6px',
  medium: '8px'
}), switchClasses.checked, switchProp('size', {
  small: '3px',
  medium: '4px'
}), switchProp('size', {
  small: '16px',
  medium: '20px'
}), switchClasses.track, palette('primary'), palette('primary'), switchClasses.disabled, switchClasses.track, withUtility(({
  palette,
  isLight
}, {
  error
}) => {
  if (error) {
    return css(_t3 || (_t3 = _`
        & .${0} {
          background-color: ${0};
        }

        & .${0} {
          background-color: ${0};
          border: 1px solid ${0};
        }

        & .${0} .${0} {
          background-color: ${0};
        }

        & .${0} {
          &.${0} {
            & + .${0} {
              background-color: ${0};
              border: 1px solid ${0};
            }
          }
        }
      `), switchClasses.thumb, palette('error'), switchClasses.track, palette('errorContainer'), palette('error'), switchClasses.checked, switchClasses.thumb, palette(isLight ? 'surface' : 'errorContainer'), switchClasses.switchBase, switchClasses.checked, switchClasses.track, palette('error'), palette('error'));
  } else {
    return css(_t4 || (_t4 = _``));
  }
}));
const Switch = _a => {
  var {
      margin,
      marginTop,
      marginBottom,
      marginLeft,
      marginRight,
      m,
      marginX,
      marginY,
      mb,
      ml,
      mt,
      mr,
      mx,
      my,
      label,
      direction,
      size = 'medium'
    } = _a,
    props = __rest(_a, ["margin", "marginTop", "marginBottom", "marginLeft", "marginRight", "m", "marginX", "marginY", "mb", "ml", "mt", "mr", "mx", "my", "label", "direction", "size"]);
  const isLeftDirection = direction === 'left';
  return label ? jsx(FormControlLabel, {
    sx: {
      flexDirection: isLeftDirection ? 'row' : 'row-reverse',
      margin,
      marginTop,
      marginBottom,
      marginLeft,
      marginRight,
      m,
      marginX,
      marginY,
      mb,
      ml,
      mt,
      mr,
      mx,
      my
    },
    control: jsx(Content, Object.assign({}, props, {
      mr: isLeftDirection ? 3 : 0,
      ml: isLeftDirection ? 0 : 3,
      size: size
    })),
    label: label
  }) : jsx(Content, Object.assign({}, props, {
    size: size,
    margin: margin,
    marginTop: marginTop,
    marginBottom: marginBottom,
    marginLeft: marginLeft,
    marginRight: marginRight,
    m: m,
    marginX: marginX,
    marginY: marginY,
    mb: mb,
    ml: ml,
    mt: mt,
    mr: mr,
    mx: mx,
    my: my
  }));
};
Switch.defaultProps = {
  disableRipple: true
};

export { Switch };
